"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HEAD_CELL_HEIGHT = exports.CELL_HEIGHT = void 0;
const HEAD_CELL_HEIGHT = 40;
exports.HEAD_CELL_HEIGHT = HEAD_CELL_HEIGHT;
const CELL_HEIGHT = 41;
exports.CELL_HEIGHT = CELL_HEIGHT;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJIRUFEX0NFTExfSEVJR0hUIiwiQ0VMTF9IRUlHSFQiXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9UYWJsZS9UYWJsZS5jb25zdHMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IEhFQURfQ0VMTF9IRUlHSFQgPSA0MFxuZXhwb3J0IGNvbnN0IENFTExfSEVJR0hUID0gNDFcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQU8sTUFBTUEsZ0JBQWdCLEdBQUcsRUFBekI7O0FBQ0EsTUFBTUMsV0FBVyxHQUFHLEVBQXBCIn0=